export default __webpack_public_path__ + "static/media/karmakanda.e6c98771.jpg";